import Service from './service';
import { AxiosResponse } from 'axios';

const Config = require('Config');

class InvoiceManagerService extends Service {
  constructor() {
    super(Config.newFinancialServiceUrl);
  }

  async getIMUser(email): Promise<any> {
    const url = `/user/${email}`;
    try {
      const response: AxiosResponse = await this.axios.get(url);
      return response.data;
    } catch (error) {
      if (error.response.data.code === 404) {
        throw new Error('No IM User.');
      }
    }
  }

  async saveIMUser(email, body, replace): Promise<any> {
    let replaceString = '';
    if (replace) {
      replaceString = '?replace=true';
    }

    const response: AxiosResponse = await this.axios.patch(`/user/${email}${replaceString}`, body);
    return response.data;
  }

  async addUserAccount(clientId: string, email: string): Promise<any> {
    const url = `user/addAccount/${clientId}`;
    const response: AxiosResponse = await this.axios.patch(url, {email});
    return response.data;
  }

  async removeUserAccount(clientId: string, email: string, newActiveAccount: string): Promise<any> {
    const url = `user/removeAccount/${clientId}`;
    const response: AxiosResponse = await this.axios.patch(url, {email, newActiveAccount});
    return response.data;
  }
}

export default new InvoiceManagerService();